module.exports = "<div style=\"padding:20px;text-align:center;\">\n    <marquee ><span style=\"font-size: 20px;\">Note:-</span>If there is miss information given by the applicant, it leads to cancellation of application.</marquee>\n  <h1>Dashboard</h1>\n<h4>Coming soon</h4>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main